import { render } from "./HiAuBusinessDetails.vue?vue&type=template&id=567820fa&scoped=true"
import script from "./HiAuBusinessDetails.vue?vue&type=script&lang=js"
export * from "./HiAuBusinessDetails.vue?vue&type=script&lang=js"

import "./HiAuBusinessDetails.vue?vue&type=style&index=0&id=567820fa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567820fa"]])

export default __exports__